import { Stack } from '@mui/material'
import { CalendarDotsIcon, MicrosoftExcelLogoIcon, NotePencilIcon } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'

export type TenantImportFormatCopy = {
    title: string
    template: string
    periods: string
    remarks: string
}

export function TenantImportFormatInfo({ copy }: { copy: TenantImportFormatCopy }) {
    const items = [
        { Icon: MicrosoftExcelLogoIcon, text: copy.template },
        { Icon: CalendarDotsIcon, text: copy.periods },
        { Icon: NotePencilIcon, text: copy.remarks },
    ]

    return (
        <Stack
            component="section"
            aria-label={copy.title}
            sx={{ display: 'flex', flexDirection: 'column', gap: tokens.SizingSpacing200, minWidth: 0 }}
        >
            <Typography variant="headline3" color={tokens.ColorTextBoldest}>
                {copy.title}
            </Typography>
            <Stack component="ul" gap={tokens.SizingSpacing150} sx={{ padding: 0, margin: 0, listStyle: 'none' }}>
                {items.map(({ Icon, text }) => (
                    <Stack key={text} component="li" direction="row" gap={tokens.SizingSpacing075} alignItems="flex-start">
                        <Icon
                            size={tokens.SizingIconS}
                            weight="bold"
                            color={tokens.ColorIconDefault}
                            style={{ flexShrink: 0, marginTop: '1px' }}
                            aria-hidden
                        />
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {text}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    )
}
